var path = 'app/components/common/navbar/profilePicture.html';
var html = "<div class=\"profile-picture\"><a href=\"index.html\"><i class=\"fa fa-user-md fa-4x\"></i></a><div class=\"stats-label text-color\"><span class=\"font-extra-bold font-uppercase\">DentalLAB</span><div class=\"dropdown\"><a class=\"dropdown-toggle\" href=\"#\" data-toggle=\"dropdown\"><small class=\"text-muted\">{{vm.user.username}} <b class=\"caret\"></b></small></a><ul class=\"dropdown-menu animated fadeInRight m-t-xs\"><li><a ui-sref=\"login\">Odjava</a></li><li><a ng-click=\"vm.activateNotification()\">Notificiraj me na ovoj lokaciji</a></li><li><a ng-click=\"vm.updateServiceWorker()\">Update SW</a></li></ul></div></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/common/navbar/profilePicture.html
// module id = 187
// module chunks = 0